/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ClinicDetailsById, ClinicInfoFormData } from './clinicHelper';
import ViewDepartmentDetails from './ViewDepartmentDetails';
import { useTranslation } from 'react-i18next';





interface ViewClinicDetailsProps {
  id: number | null;
  onBack: () => void;
}

const ViewClinicDetails: React.FC<ViewClinicDetailsProps> = ({ id, onBack }) => {
  const navigate = useNavigate();
  const [clinic, setClinic] = useState<ClinicInfoFormData | null>(null);
  const [activeStep, setActiveStep] = useState(0);
  const { t: tClinic } = useTranslation('clinic_config');

  const steps = [
    tClinic('AddNewClinic_Page.Clinic_Details'),
    tClinic('AddNewClinic_Page.Department_Store_Details'),
  ];


  const labelMap: { [key: string]: string } = {
    name: tClinic('AddNewClinic_Page.Text_Clinic Name') || 'Clinic Name',
    code: tClinic('AddNewClinic_Page.Text_Code') || 'Code',
    description: tClinic('AddNewClinic_Page.Text_description') || 'description',
    email: tClinic('AddNewClinic_Page.Text_Clinic Email') || 'Clinic Email',
    phone: tClinic('AddNewClinic_Page.Text_Mobile No.') || 'Mobile No.',
    country: tClinic('AddNewClinic_Page.Text_Country') || 'Country',
    state: tClinic('AddNewClinic_Page.Text_State') || 'State',
    city: tClinic('AddNewClinic_Page.Text_City') || 'City',
    line_1: tClinic('AddNewClinic_Page.Text_Address Line 1') || 'Address Line 1',
    line_2: tClinic('AddNewClinic_Page.Text_Address Line 2') || 'Address Line 2',
    pincode: tClinic('AddNewClinic_Page.Text_Pin/Zip Code') || 'Pin/Zip Code',
    tin_no: tClinic('AddNewClinic_Page.Text_VAT No.') || 'VAT No.',
    gst_no: tClinic('AddNewClinic_Page.Text_GST IN No.') || 'GST IN No.',
    fax_no: tClinic('AddNewClinic_Page.Text_Clinic Fax No.') || 'Clinic Fax No.',
    cluster: tClinic('AddNewClinic_Page.Text_Cluster') || 'Cluster',
    server: tClinic('AddNewClinic_Page.Text_Server') || 'Server',
    database: tClinic('AddNewClinic_Page.Text_Database') || 'Database',
    licence_no: tClinic('AddNewClinic_Page.Text_Drug License No.') || 'Drug License No.',
    registration_no: tClinic('AddNewClinic_Page.Text_Clinic Registration No. (CIN)') || 'Clinic Registration No. (CIN)',
    establishment_no: tClinic('AddNewClinic_Page.Text_Shop Or Establishment No.') || 'Shop Or Establishment No.',
    pan_no: tClinic('AddNewClinic_Page.Text_PAN No.') || 'PAN No.',
  };


  useEffect(() => {
    if (id) {
      ClinicDetailsById((id)).then((data) => {
        setClinic(data);
      });
    }
  }, [id]);

  const renderStepper = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>{tClinic('AddNewClinic_Page.Text_ViewClinicDetails')}</Typography>
      <Box>
        <Box
          sx={{
            borderRadius: 3,
            p: 1.5,
            width: 700,
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            boxShadow: 1,
          }}
        >
          {steps.map((label, idx) => (
            <React.Fragment key={label}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: idx === activeStep ? '#FFEBE6' : '#BDBDBD',
                    color: idx === activeStep ? '#FF6F61' : '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontSize: 16,
                    transition: 'background 0.2s',
                  }}
                >
                  {idx + 1}
                </Box>
                <Typography
                  sx={{
                    color: idx === activeStep ? '#FF6F61' : '#757575',
                    fontWeight: idx === activeStep ? 600 : 500,
                    fontSize: 16,
                    ml: 0.5,
                    mr: 0,
                    transition: 'color 0.2s',
                  }}
                >
                  {label}
                </Typography>
              </Box>
              {idx < steps.length - 1 && (
                <Box
                  sx={{
                    width: 48,
                    height: 2,
                    bgcolor: '#E0E0E0',
                    mx: 1,
                    borderRadius: 1,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };
  const handleBack = () => {
    onBack();
  };
  return (
    <Box p={3}>
      {/* Stepper */}
      {renderStepper()}
      {/* Details Grid */}
      {activeStep === 0 ? (
        <>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, mb: 4 }}>
            {clinic && (
              <>
                {Object.entries(labelMap).map(([key, label]) => {
                  const value = clinic[key as keyof ClinicInfoFormData];
                  if (Array.isArray(value) || (typeof value === 'object' && value !== null)) return null;
                  return (
                    <Box key={key} sx={{ minWidth: 260, mb: 2 }}>
                      <Typography variant="body2" sx={{ color: '#BBBBBB', fontWeight: 500 }}>{label}</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 'bold'}}>{value || '-'}</Typography>
                    </Box>
                  );
                })}
              </>
            )}
          </Box>
          {/* // Action Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mt: 4 }}>
            <Button variant="outlined" sx={{ fontWeight: 700, borderRadius: 2, px: 3, py: 1 }} onClick={onBack}>{tClinic('AddNewClinic_Page.Text_BackButton')}</Button>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#3e3e3e',
                  color: '#fff',
                  fontWeight: 700,
                  boxShadow: 'none',
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  '&:hover': { backgroundColor: '#222' },
                }}
                onClick={() => {
                  if (clinic && clinic.id) {
                    navigate(`/ai/configuration/clinic/${clinic.id}`);
                  }
                }}
              >
                {tClinic('AddNewClinic_Page.Text_EditButton')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#3e3e3e',
                  color: '#fff',
                  fontWeight: 700,
                  boxShadow: 'none',
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  '&:hover': { backgroundColor: '#222' },
                }}
                onClick={() => {handleNext();}}
              >
                {tClinic('AddNewClinic_Page.Text_Next')}
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <ViewDepartmentDetails departments={clinic?.departments || []} onBack={handleBack} />
        </>
      )}
    </Box>
  );
};
  
export default ViewClinicDetails;